import React from 'react';
import { useNavigate } from 'react-router-dom';
import BoldTemplate from '../components/templates/BoldTemplate';
import CleanTemplate from '../components/templates/CleanTemplate';
import './Landing.css';

const demoProfileData = {
  settings: {
    accent_color: '#e32c74',
    heading_font: 'Cormorant Garamond',
    body_font: 'Cormorant Garamond',
    heading_font_size: '32',
    body_font_size: '16',
    media_mode: 'gallery_only',
  },
  performer: {
    display_name: 'Olivia Chen',
    tagline: 'Actor & Singer',
    bio: 'NYC-based actor and singer with a passion for new works and musical theater. Graduate of NYU Tisch School of the Arts. Represented by TalentWorks.',
    job_title: 'Actor & Singer',
  },
  credits: {
    'Musical Theater': [
      { show: 'Hamilton', role: 'Eliza Hamilton', venue: 'Broadway', year: '2025' },
      { show: 'Into the Woods', role: 'Cinderella', venue: 'Public Theater', year: '2024' },
      { show: 'Spring Awakening', role: 'Wendla', venue: 'Roundabout', year: '2023' },
    ],
    'Film & TV': [
      { show: 'The Morning Show', role: 'Guest Star', venue: 'Apple TV+', year: '2024' },
    ],
  },
  skills: ['Singing (Soprano)', 'Dance (Ballet, Jazz)', 'Dialects (British RP, Southern)'],
  media: [
    {
      id: 1,
      media_type: 'image',
      slot: 'headshot',
      url: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=800&h=1000&fit=crop&crop=face',
      position_x: 50,
      position_y: 20,
      zoom: 100,
    },
    {
      id: 2,
      media_type: 'image',
      slot: 'headshot',
      url: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=800&h=1000&fit=crop&crop=face',
      position_x: 50,
      position_y: 30,
      zoom: 100,
    },
    {
      id: 3,
      media_type: 'image',
      slot: 'about',
      url: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=800&h=1000&fit=crop&crop=face',
      position_x: 50,
      position_y: 30,
      zoom: 100,
    },
    {
      id: 4,
      media_type: 'image',
      slot: 'gallery',
      url: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=800&h=1000&fit=crop&crop=face',
      position_x: 50,
      position_y: 20,
      zoom: 100,
      sort_order: 1,
    },
    {
      id: 5,
      media_type: 'image',
      slot: 'gallery',
      url: 'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=800&h=1000&fit=crop&crop=face',
      position_x: 50,
      position_y: 20,
      zoom: 100,
      sort_order: 2,
    },
  ],
  links: [],
};

const demoBasicUser = {
  full_name: 'Olivia Chen',
  username: 'oliviachen',
  industry: 'Musical Theater',
};

function PortfolioDemo() {
  const navigate = useNavigate();
  const [activeTemplate, setActiveTemplate] = React.useState('bold');

  return (
    <section className="land-demo">
      <h2 className="land-section-title">See it in action.</h2>
      <p className="land-demo-sub">
        Here are just a couple of our templates. Join to explore more and build your own.
      </p>

      <div className="land-demo-tabs">
        <button
          className={`land-demo-tab ${activeTemplate === 'bold' ? 'active' : ''}`}
          onClick={() => setActiveTemplate('bold')}
        >
          Bold
        </button>
        <button
          className={`land-demo-tab ${activeTemplate === 'clean' ? 'active' : ''}`}
          onClick={() => setActiveTemplate('clean')}
        >
          Clean
        </button>
      </div>

      <div className="land-demo-browser">
        <div className="land-demo-browser-bar">
          <div className="land-demo-browser-dots">
            <span />
            <span />
            <span />
          </div>
          <div className="land-demo-browser-url">showcase-online.com/olivia-chen</div>
        </div>
        <div className="land-demo-viewport">
          <div className="land-demo-scale-wrap">
            {activeTemplate === 'bold' ? (
              <BoldTemplate
                profileData={demoProfileData}
                basicUser={demoBasicUser}
                isOwnProfile={false}
                onEdit={() => {}}
                hiddenSections={[]}
              />
            ) : (
              <CleanTemplate
                profileData={demoProfileData}
                basicUser={demoBasicUser}
                isOwnProfile={false}
                onEdit={() => {}}
                hiddenSections={[]}
              />
            )}
          </div>
        </div>
      </div>

      <button className="land-btn-primary land-demo-cta" onClick={() => navigate('/register')}>
        Join to Create Yours
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line x1="5" y1="12" x2="19" y2="12" />
          <polyline points="12 5 19 12 12 19" />
        </svg>
      </button>
    </section>
  );
}

function Landing() {
  const navigate = useNavigate();

  return (
    <div className="land">
      {/* Tagline Bar */}
      <div className="land-tagline-bar">Your Network. Your Spotlight.</div>

      {/* Hero */}
      <section className="land-hero-split">
        <div className="land-hero-left">
          <div className="land-hero-content">
            <h1 className="land-hero-title">
              The professional network
              <br />
              <span className="land-hero-highlight">built for theater.</span>
            </h1>
            <p className="land-hero-sub">
              The only networking platform made for theater professionals. Build your portfolio
              website, connect with your industry, and find your next opportunity — all in one
              place, completely free.
            </p>
            <div className="land-hero-actions">
              <button className="land-btn-primary" onClick={() => navigate('/register')}>
                Join Showcase Free
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="5" y1="12" x2="19" y2="12" />
                  <polyline points="12 5 19 12 12 19" />
                </svg>
              </button>
              <button className="land-hero-signin" onClick={() => navigate('/login')}>
                Already have an account? Sign in
              </button>
            </div>
          </div>
        </div>
        <div className="land-hero-right">
          <img src="/logo.png" alt="Showcase" className="land-hero-logo" />
        </div>
      </section>

      {/* Rainbow divider */}
      <div className="land-rainbow" />

      {/* Value Props */}
      <section className="land-features">
        <div className="land-features-grid land-features-top">
          <div className="land-feature-card">
            <div className="land-feature-accent" style={{ background: '#5a407d' }} />
            <div className="land-feature-icon">
              <svg
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#5a407d"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
            </div>
            <h3>Professional Networking</h3>
            <p>
              Connect with actors, stage managers, directors, designers, and every creative who
              makes theater happen. Your professional network, purpose-built for the industry.
            </p>
          </div>

          <div className="land-feature-card">
            <div className="land-feature-accent" style={{ background: '#e32c74' }} />
            <div className="land-feature-icon">
              <svg
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#e32c74"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
                <line x1="8" y1="21" x2="16" y2="21" />
                <line x1="12" y1="17" x2="12" y2="21" />
              </svg>
            </div>
            <h3>Your Portfolio Website</h3>
            <p>
              Build a beautiful, fully customizable portfolio site with your headshots, resume,
              reels, and credits. Choose from stunning templates and make it yours.
            </p>
          </div>
        </div>

        <h2 className="land-section-title land-features-title">Showcase was built for you.</h2>

        <div className="land-features-grid land-features-bottom">
          <div className="land-feature-card">
            <div className="land-feature-accent" style={{ background: '#f57b57' }} />
            <div className="land-feature-icon">
              <svg
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#f57b57"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
                <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
              </svg>
            </div>
            <h3>One Link, Share Anywhere</h3>
            <p>
              Send your Showcase link to anyone — casting directors, producers, collaborators. They
              see your full portfolio instantly, no sign-up required to view.
            </p>
          </div>

          <div className="land-feature-card">
            <div className="land-feature-accent" style={{ background: '#f29d40' }} />
            <div className="land-feature-icon">
              <svg
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#f29d40"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
                <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
              </svg>
            </div>
            <h3>Jobs & Opportunities</h3>
            <p>
              Browse casting calls, crew positions, and gigs in one place. Your resume and portfolio
              are already built in — applying has never been faster.
            </p>
          </div>
        </div>
      </section>

      {/* Portfolio Demo */}
      <PortfolioDemo />

      {/* Split showcase preview */}
      <section className="land-split">
        <div className="land-split-left">
          <div className="land-split-content">
            <h2>
              Two sides of your career.
              <br />
              One platform.
            </h2>
            <p>
              Your Showcase is your professional portfolio — a beautiful, shareable website with
              your headshots, resume, reels, credits, and design work.
            </p>
            <p>
              Your Profile is your networking home — posts, connections, and conversations with the
              people who make the work happen.
            </p>
            <button className="land-btn-primary" onClick={() => navigate('/register')}>
              Build Yours Free
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </button>
          </div>
        </div>
        <div className="land-split-right">
          <div className="land-split-mockup">
            <div className="land-mockup-card land-mockup-showcase">
              <div className="land-mockup-bar" />
              <div className="land-mockup-photo" />
              <div className="land-mockup-name" />
              <div className="land-mockup-tagline" />
              <div className="land-mockup-nav">
                <span />
                <span />
                <span />
                <span />
              </div>
            </div>
            <div className="land-mockup-card land-mockup-social">
              <div className="land-mockup-post">
                <div className="land-mockup-avatar" />
                <div className="land-mockup-lines">
                  <span />
                  <span />
                </div>
              </div>
              <div className="land-mockup-post">
                <div className="land-mockup-avatar" />
                <div className="land-mockup-lines">
                  <span />
                  <span />
                </div>
              </div>
              <div className="land-mockup-post">
                <div className="land-mockup-avatar" />
                <div className="land-mockup-lines">
                  <span />
                  <span />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Who it's for */}
      <section className="land-who">
        <div className="land-who-inner">
          <h2 className="land-section-title">
            Built for every creative
            <br />
            in the theater industry.
          </h2>
          <p className="land-section-sub">
            Whether you're on stage, backstage, or behind the desk.
          </p>
          <div className="land-who-grid">
            <div className="land-who-role">
              <span className="land-who-dot" style={{ background: '#5a407d' }} />
              Actors
            </div>
            <div className="land-who-role">
              <span className="land-who-dot" style={{ background: '#e32c74' }} />
              Directors
            </div>
            <div className="land-who-role">
              <span className="land-who-dot" style={{ background: '#f57b57' }} />
              Stage Managers
            </div>
            <div className="land-who-role">
              <span className="land-who-dot" style={{ background: '#f29d40' }} />
              Designers
            </div>
            <div className="land-who-role">
              <span className="land-who-dot" style={{ background: '#5a407d' }} />
              Agents
            </div>
            <div className="land-who-role">
              <span className="land-who-dot" style={{ background: '#e32c74' }} />
              Playwrights
            </div>
            <div className="land-who-role">
              <span className="land-who-dot" style={{ background: '#f57b57' }} />
              Choreographers
            </div>
            <div className="land-who-role">
              <span className="land-who-dot" style={{ background: '#f29d40' }} />
              Crew &amp; Props
            </div>
          </div>
        </div>
      </section>

      {/* Social proof / tagline */}
      <section className="land-proof">
        <div className="land-proof-inner">
          <h2>
            Your network.
            <br />
            Your spotlight.
          </h2>
          <p>
            No hidden fees. No premium tiers. No ads. Just the tools you actually need to connect
            and get seen.
          </p>
          <div className="land-proof-stats">
            <div className="land-proof-stat">
              <span className="land-proof-stat-icon" style={{ background: '#5a407d' }}>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#fff"
                  strokeWidth="2"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path d="M8 14s1.5 2 4 2 4-2 4-2" />
                  <line x1="9" y1="9" x2="9.01" y2="9" />
                  <line x1="15" y1="9" x2="15.01" y2="9" />
                </svg>
              </span>
              <span>Free forever</span>
            </div>
            <div className="land-proof-stat">
              <span className="land-proof-stat-icon" style={{ background: '#e32c74' }}>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#fff"
                  strokeWidth="2"
                >
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              </span>
              <span>No sign-up to view</span>
            </div>
            <div className="land-proof-stat">
              <span className="land-proof-stat-icon" style={{ background: '#f57b57' }}>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#fff"
                  strokeWidth="2"
                >
                  <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
                </svg>
              </span>
              <span>Shareable link</span>
            </div>
            <div className="land-proof-stat">
              <span className="land-proof-stat-icon" style={{ background: '#f29d40' }}>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#fff"
                  strokeWidth="2"
                >
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                </svg>
              </span>
              <span>Your data, your control</span>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="land-cta">
        <div className="land-rainbow" />
        <div className="land-cta-inner">
          <img src="/logo.png" alt="Showcase" className="land-cta-logo" />
          <h2>Your spotlight is waiting.</h2>
          <p>
            Join the professional network made for theater. Build your portfolio, grow your network,
            find your next gig — all for free.
          </p>
          <button className="land-btn-primary land-btn-lg" onClick={() => navigate('/register')}>
            Get Started Free
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </button>
          <button className="land-btn-ghost" onClick={() => navigate('/login')}>
            Already have an account? Sign in
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="land-footer">
        <span className="land-footer-brand">Showcase.</span>
        <span className="land-footer-copy">
          &copy; {new Date().getFullYear()} Showcase. Your Network. Your Spotlight.
        </span>
      </footer>
    </div>
  );
}

export default Landing;
